import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cancelFormat'
})
export class CancelFormatPipe implements PipeTransform {

transform(info: any): any[] {
    const cancel = info?.extra_info?.cancel;
    const pax = info?.segments?.[0]?.passengers;

    if (!cancel) return [];

    const typeMap: any = { '1': 'Adult', '2': 'Child', '3': 'Infant' };
    const grouped = pax?.reduce((acc: any, p: any) => {
      const t = p?.type?.toLowerCase() || 'unknown';
      acc[t] = (acc[t] || 0) + 1;
      return acc;
    }, {}) || {};

    // Case 1: cancel is array
    if (Array.isArray(cancel)) {
      return [{
        route: '',
        items: cancel.map((item: any, idx: number) => ({
          type: item?.free_text?.trim() || 'Info',
          value: item?.value?.trim() || 'N/A',
          index: idx + 1
        }))
      }];
    }

    // Case 2: cancel is object grouped by route and pax type
    return Object.entries(cancel).map(([route, paxTypeObj]: any) => {
      const items: any[] = [], indexMap: any = {};

      Object.entries(paxTypeObj).forEach(([typeCode, values]: any) => {
        const typeLabel = typeMap[typeCode] || `Pax ${typeCode}`;
        const groupKey = typeLabel.toLowerCase();
        const count = grouped[groupKey] || 0;

        for (let i = 0; i < count; i++) {
          Object.values(values).forEach(val => {
            const idx = (indexMap[typeLabel] = (indexMap[typeLabel] || 0) + 1);
            items.push({
              type: typeLabel,
              value: String(val).trim() || 'N/A',
              index: idx
            });
          });
        }
      });

      return {
        route: route.replace(/_/g, '-').toLowerCase(),
        items
      };
    });
  }

}
